(() => {
  const configureMobileActivator = (chat) => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const idleAttribute = 'data-cs-chat-idle';
    let timer;
    let runtime;
    const style = document.createElement('style');
    style.id = 'cansweet-mobile-chat-style';
    style.textContent = `
      @media (max-width: 749px) {
        shopify-chat::part(activator) {
          height: 38px;
          padding-inline: 8px;
          border-radius: 12px;
          transition: opacity 250ms ease, visibility 250ms ease;
        }
        shopify-chat[data-cs-chat-idle]::part(activator) {
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
        }
      }
      @media (max-width: 749px) and (prefers-reduced-motion: reduce) {
        shopify-chat::part(activator) { transition: none; }
      }
    `;
    document.head.append(style);
    const getRuntime = () => chat.shadowRoot?.querySelector('shopify-agent-runtime');
    const isOpen = () => chat.hasAttribute('open') ||
      getRuntime()?.hasAttribute('open') ||
      getRuntime()?.shadowRoot?.querySelector('[part="activator"]')?.getAttribute('aria-expanded') === 'true';
    const hasFocus = () => {
      let active = document.activeElement;
      while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
      return active?.matches(':focus-visible') && document.activeElement === chat;
    };
    const reveal = () => {
      window.clearTimeout(timer);
      chat.removeAttribute(idleAttribute);
    };
    const watchRuntime = () => {
      const current = getRuntime();
      if (!current || current === runtime) return;
      runtime = current;
      new MutationObserver(refresh).observe(current, {
        attributes: true, attributeFilter: ['open']
      });
    };
    const refresh = () => {
      reveal();
      watchRuntime();
      if (!mobile.matches || isOpen()) return;
      timer = window.setTimeout(() => {
        watchRuntime();
        if (mobile.matches && !isOpen() && !hasFocus()) chat.setAttribute(idleAttribute, '');
      }, 5000);
    };
    window.addEventListener('scroll', refresh, { passive: true });
    mobile.addEventListener('change', refresh);
    chat.addEventListener('pointerdown', reveal, true);
    chat.addEventListener('focusin', reveal);
    chat.addEventListener('focusout', () => window.setTimeout(refresh, 0));
    chat.addEventListener('click', () => window.requestAnimationFrame(refresh));
    new MutationObserver(refresh).observe(chat, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
      else window.clearTimeout(timer);
    });
    refresh();
    customElements.whenDefined('shopify-chat').then(refresh);
  };
  const attach = (chat) => {
    let activated = false;
    const close = () => chat.removeAttribute('open');
    const observer = new MutationObserver(() => {
      if (!activated && chat.hasAttribute('open')) close();
    });
    observer.observe(chat, { attributes: true, attributeFilter: ['open'] });
    const activate = () => {
      activated = true;
      observer.disconnect();
    };
    chat.addEventListener('pointerdown', activate, true);
    chat.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') activate();
    }, true);
    chat.addEventListener('click', () => {
      if (!activated) activate();
    }, true);
    close();
    configureMobileActivator(chat);
    customElements.whenDefined('shopify-chat').then(() => {
      if (!activated) close();
    });
  };
  const findChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    attach(chat);
    return true;
  };
  if (!findChat()) {
    const observer = new MutationObserver(() => {
      if (findChat()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
